import { Box, Card, Grid, Typography } from '@mui/material';

import {
  SendRequestForm,
  useSupportPageStyles
} from '@uplift/pages';
import { useL10n } from '@uplift/hooks';

import { MainLayout } from '../../components';
import { UpliftThemeProvider } from '@uplift/ui-v2';


export const SupportPage = () => {
  const l10n = useL10n();
  const { classes } = useSupportPageStyles();

  return (
    <MainLayout>
      <UpliftThemeProvider>
        <Box mb={7} color="darkSlate">
          <Typography variant="h3">{l10n.pages.support}</Typography>
        </Box>
        <Box mb={5} color="darkSlate">
          <Typography variant="h1">{l10n.support.pageTitle}</Typography>
        </Box>

        <Box display="flex" flex={1}>
          <Grid container className={classes.grid}>
            <Box className={classes.gridItem}>
              <Card className={classes.cardLeft}>
                <SendRequestForm />
              </Card>
            </Box>
            <Box className={classes.gridItem}>
              <Card className={classes.cardRight}>
                <Typography variant="h4" color="secondary" className={classes.cardTitle}>{l10n.support.giveCall}</Typography>
                <Box color="darkSlate" mt={4}>
                  <Typography variant="h4">{l10n.support.supportNumber}</Typography>
                </Box>
                <Box mt={3}>
                  <Typography>
                    <span dangerouslySetInnerHTML={{ __html: l10n.support.supportAvailabilityPatient }}/>
                  </Typography>
                </Box>
              </Card>
            </Box>
          </Grid>
        </Box>
        <Box className={classes.footer}>
          <Typography variant="caption" color="textSecondary">
            <span dangerouslySetInnerHTML={{ __html: l10n.support.footerPatient }}/>
          </Typography>
        </Box>
      </UpliftThemeProvider>
    </MainLayout>
  );
};
